export const BATCH_STUDIO_ROUTE = '/batch-studio'
